module.exports = __webpack_public_path__ + "img/国家双软认证企业.2c882d89.svg";